module.exports = "<div class=\"ui center aligned vertical expanded area\">\n  <div class=\"ui inline large slim text loader\"><slot></slot></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/scripts/shared/components/ui-loader/template.html
// module id = 94
// module chunks = 0